import script from "./not.vue?vue&type=script&setup=true&lang=js"
export * from "./not.vue?vue&type=script&setup=true&lang=js"

import "./not.vue?vue&type=style&index=0&id=1c06ff0c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c06ff0c"]])

export default __exports__